import React, { useRef, useState } from "react";
import { Carousel, Icon } from "antd";
import { FileCard } from "./documentsFileComponents";

// Renders every file belonging to a single doc type (e.g. all PODs) inside one
// small card-sized carousel instead of a single file. Slides reuse the existing
// FileCard so selection, hover preview and the preview modal keep working.
const FileCardCarousel = (props) => {
  const {
    files = [],
    enableSelection = true,
    isShipper = false,
    ...cardProps
  } = props;
  const carouselRef = useRef(null);
  const [current, setCurrent] = useState(0);

  if (!files || files.length === 0) return null;

  if (files.length === 1) {
    return (
      <FileCard
        file={files[0]}
        {...cardProps}
        isShipper={isShipper}
        enableSelection={enableSelection}
      />
    );
  }

  const goPrev = () => carouselRef.current && carouselRef.current.prev();
  const goNext = () => carouselRef.current && carouselRef.current.next();

  return (
    <div
      data-testid="file-card-carousel"
      style={{
        position: "relative",
        width: "56px",
        height: "65px",
      }}
    >
      <Carousel
        ref={carouselRef}
        dots={false}
        afterChange={(index) => setCurrent(index)}
      >
        {files.map((file, index) => (
          <div key={file?.ack_id || file?.id || file?.src || index}>
            <FileCard
              file={file}
              {...cardProps}
              isShipper={isShipper}
              enableSelection={enableSelection}
            />
          </div>
        ))}
      </Carousel>

      <span
        data-testid="file-carousel-prev"
        role="button"
        tabIndex={0}
        onClick={goPrev}
        aria-label="Previous file"
        style={{
          position: "absolute",
          left: -9,
          top: 26,
          zIndex: 10,
          cursor: "pointer",
          color: "#576EC1",
          fontSize: 12,
          background: "rgba(255,255,255,0.85)",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        }}
      >
        <Icon type="left" />
      </span>

      <span
        data-testid="file-carousel-next"
        role="button"
        tabIndex={0}
        onClick={goNext}
        aria-label="Next file"
        style={{
          position: "absolute",
          right: -9,
          top: 26,
          zIndex: 10,
          cursor: "pointer",
          color: "#576EC1",
          fontSize: 12,
          background: "rgba(255,255,255,0.85)",
          borderRadius: "50%",
          width: "18px",
          height: "18px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
        }}
      >
        <Icon type="right" />
      </span>
    </div>
  );
};

export default FileCardCarousel;
